import MarketInsightBookingCurve from '@app/model/market_insight/MarketInsightBookingCurve';
import MarketPace from '@app/model/market_insight/MarketPace';
import {
	FIND_FLIGHT_STATS_QUERY,
	FIND_LOS_INDICES_QUERY,
	FIND_MARKET_BOOKING_CURVE_QUERY,
	FIND_MARKET_INSIGHT_QUERY,
	FIND_MARKET_PACE_QUERY,
	FIND_OCCUPANCY_HEXAGONS_QUERY,
	FIND_OCCUPANCY_INDICES_QUERY,
	FIND_PRICE_INDEX_QUERY,
	FIND_SOLD_OUT_INDICES_QUERY,
} from '@app/model/market_insight/service/MarketInsightGraphQLQueries';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import MarketInsight from '@app/model/market_insight/MarketInsight';
import MarketInsightPriceIndex from '@app/model/market_insight/MarketInsightPriceIndex';
import MarketInsightSoldOutIndices from '@app/model/market_insight/SoldOutIndices';
import MarketInsightLosIndices from '@app/model/market_insight/LosIndices';
import MarketInsightOccupancy from '@app/model/market_insight/MarketInsightOccupancy';
import MarketInsightFlightStat from '@app/model/market_insight/MarketInsightFlightStat';
import MarketInsightOccupancyMap from '@app/model/market_insight/MarketInsightOccupancyMap';


export default class MarketInsightService {
    public static findMarketPace(variables: { companyHotelId: number, fromDate: string, toDate: string }) {
        return GraphQLExecutor.execute<MarketPace | null>(FIND_MARKET_PACE_QUERY, variables);
    }

    public static findMarketBookingCurve(variables: { companyHotelId: number, statDate: string, nights: number, stars: number, marketAreaId?: number | null }) {
        return GraphQLExecutor.execute<MarketInsightBookingCurve | null>(FIND_MARKET_BOOKING_CURVE_QUERY, variables);
    }


	public static findMarketInsight(variables: {
		companyHotelId: number,
		skipDays: number
	}) {
		return GraphQLExecutor.execute<MarketInsight>(FIND_MARKET_INSIGHT_QUERY, variables);
	}

	public static findPriceIndex(variables: {
		companyHotelId: number,
		statDate: string,
		marketAreaId?: number | null
	}) {
		return GraphQLExecutor.execute<MarketInsightPriceIndex>(FIND_PRICE_INDEX_QUERY, variables);
	}

	public static findSoldOutIndices(variables: {
		companyHotelId: number,
		statDate: string,
		marketAreaId?: number | null
	}) {
		return GraphQLExecutor.execute<MarketInsightSoldOutIndices>(FIND_SOLD_OUT_INDICES_QUERY, variables);
	}

	public static findLosIndices(variables: {
		companyHotelId: number,
		statDate: string,
		marketAreaId?: number | null
	}) {
		return GraphQLExecutor.execute<MarketInsightLosIndices>(FIND_LOS_INDICES_QUERY, variables);
	}

	public static findOccupancyIndices(variables: {
		companyHotelId: number,
		statDate: string,
		marketAreaId?: number | null
	}) {
		return GraphQLExecutor.execute<MarketInsightOccupancy>(FIND_OCCUPANCY_INDICES_QUERY, variables);
	}

	public static findFlightStats(variables: {
		companyHotelId: number,
		statDate: string,
		beforeDays: number | undefined
	}) {
		return GraphQLExecutor.execute<MarketInsightFlightStat[]>(FIND_FLIGHT_STATS_QUERY, variables);
	}

	public static findOccupancyHexagons(variables: {
		companyHotelId: number,
		statDate: string,
		marketAreaId?: number | null
	}) {
		return GraphQLExecutor.execute<MarketInsightOccupancyMap>(FIND_OCCUPANCY_HEXAGONS_QUERY, variables);
	}
}